import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'github-markdown-css/github-markdown-light.css';
import 'katex/dist/katex.min.css';



//NProgress
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

// element-ui
import ElementUI from 'element-ui';
Vue.use(ElementUI, { size: 'small', });

 

//avue
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
Vue.use(Avue);

// icon
import './assets/icons' 

import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
Vue.use(vuescroll);

//载入mixin
// import mixins from '@/mixins/'
// Vue.mixin({
//   ...mixins
// })

import { info} from '@/apis/oms/common'


const whiteList = ['/login', '/register'] 
router.beforeEach((to, from, next) => {
  //判断是否登录
  let path = to.path;
  if (whiteList.indexOf(path) == -1) {
    if (store.state.userInfo.token == null) {
      var loginUrl = '/login';
      router.push({ path: loginUrl });
    } else {
      if (store.state.userInfo.user) {
        NProgress.start()
        next()
      } else { 
        info().then(data => { 
          store.dispatch('update_userinfo', data).then(res => {
            NProgress.start()
            next()
          })
        })
      }
    }
  } else {
    NProgress.start()
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

Vue.config.productionTip = false

//注册地区控件
import areaCascader from './components/area.vue';
Vue.component('areaCascader', areaCascader);

//下拉树控件
import SelectTree from './components/SelectTree.vue';
Vue.component('SelectTree', SelectTree);

//分页控件
import Pagination from './components/Pagination.vue';
Vue.component('Pagination', Pagination);

Vue.config.productionTip = false

console.log(process.env.VUE_APP_BASEPATH);




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
